import React, { useContext } from "react";

import { Markup } from "interweave";
import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
import { LocationContext } from "../../../CustomHelper/Helper";
import NodataAvailable from "../../Common/NodataAvailable";
import { serverInfo } from "../../../App";

const MarketPlaceTab = ({ user }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const { slectedCurrency, payStatus } = useContext(LocationContext);

  const handelCuntrybasePrice = (fee) => {
    return (Number(fee) * Number(slectedCurrency?.currency_value)).toFixed(0);
  };

  return (
    <>
      {user.length === 0 ? (
        <NodataAvailable />
      ) : (
        <div className="card card-bg1 p-3 mb-2">
          <div className="bg-adrk p-3 card AuctionsA  ">
            <div className=" row TabMar">
              <div className="col-md-6">
                <OwlCarousel
                  items={1}
                  loop
                  autoplay
                  autoplayTimeout={3000}
                  margin={0}
                  dots={false}
                >
                  <img
                    src={imageCdnUrl + user?.image}
                    alt=""
                    className="img-fluid AuctionsImg "
                  />
                </OwlCarousel>
              </div>

              <div className="col-md-6 containerAuc px-3">
                <div className="w-100">
                  <h3> {user.title}</h3>
                  <p className="text-light ">
                    <Markup
                      content={user.description.substring(0, 100)}
                    ></Markup>
                  </p>

                  <div className="text-light ">
                    <span className="DollarPrice fw-bold">
                      {handelCuntrybasePrice(user.unit_price)}
                    </span>
                    &nbsp;
                    <small className="text-light ">
                      {" "}
                      {slectedCurrency?.symbol}
                    </small>
                  </div>
                  <div className="d-flex mt-2 JerseyAucPro w-100">
                    <img
                      src={imageCdnUrl + user.superstar?.image}
                      className="AuctionProImg img-fluid"
                      alt="star-profile"
                    />
                    <span className="mx-2 mt-1 SpanAu">
                      <small className="proTextSm fw-bold">Superstar</small>
                      <div className="proTextAc">
                        {user.superstar?.first_name} {user.superstar?.last_name}
                      </div>
                    </span>
                  </div>
                  {payStatus && (
                    <Link to={`/marketplace/shipping/${user.slug}`}>
                      <button className="btn bg-warning mt-2  fw-bold w-100 JerseyAucBuy">
                        {" "}
                        Buy Now
                      </button>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MarketPlaceTab;
